import React from 'react';
import { IconProps } from '../types/types';

const USDJ: React.FC<IconProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" role="img" {...props}><path fill="#B31515" d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10Z"/><path fill="#FEFEFE" d="M12.532 4.238c-.607.361-1.17.61-2.024.899l-.787.271.86.006h.854v3.489c0 3.393-.005 3.5-.118 3.75a1.324 1.324 0 0 1-.764.734c-.743.277-1.502-.005-1.839-.69-.135-.271-.146-.35-.146-1.046v-.758l-1.546.034-.017.481c-.028.814.067 1.38.32 1.895.742 1.504 2.497 2.12 3.97 1.39.776-.39 1.226-.881 1.54-1.69l.147-.38.017-4.314C13.004 5.94 12.993 4 12.97 4c-.022 0-.219.107-.438.238Z"/><path fill="#FEFEFE" d="M7 10h2V8H7v2Z"/></svg>
);

export default USDJ;
